import React from "react"
import "./work.scss"

import Layout from "../components/layout"
import ProjectEntry from "../containers/project_entry"
import SEO from "../components/seo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquareFull } from "@fortawesome/free-solid-svg-icons"

import CarImage from "../images/car.jpg"
import PreddyImage from "../images/preddy.png"
import ReactAudioImage from "../images/react_audio_element.png"
import MillamoolahImage from "../images/millamoolah.png"

const projects = [
  {
    date: "April 2021",
    title: "Adversarial Attacks on Autonomous Cyber-Physical Systems",
    description:
      "Designing white box adervsarial attacks on Open Source autonomous vehicle perception modules",
    image: CarImage,
    tags: ["machine learning", "autonomous vehicles"],
    link: "https://www.youtube.com/watch?v=-ur1s0_EZYE&t=1s",
  },
  {
    date: "Nov 2020",
    title: "Preddy",
    description:
      "Etherum Prediction Market with an Automatic Market Maker based on the Balancer Whitepaper",
    image: PreddyImage,
    tags: ["blockchain", "ethereum", "ganache", "drizzle", "react", "solidity"],
    code: "https://github.com/millasml/preddy",
  },
  {
    date: "Oct 2020",
    title: "millamoolah",
    description:
      "Full stack MERN web application for money managing. Made with Redux, and Firebase Auth (jwtToken), deployed on AWS using docker.",
    image: MillamoolahImage,
    tags: ["mongodb", "express", "react", "node", "aws", "cloudflare", "nginx"],
    code: "https://github.com/millasml/millamoolah",
  },
  {
    date: "Aug 2020",
    title: "React Audio Element",
    description:
      "npm package that solves the problem of the HTML5 embedded audio element being unstylable, by recreating it with canvas. ~1k downloads in the first week.",
    image: ReactAudioImage,
    tags: ["npm", "react", "canvas"],
    link: "https://www.npmjs.com/package/react-audio-element",
    code: "https://github.com/millasml/react-audio-element",
  },
]

const WorkPage = () => (
  <Layout>
    <SEO title="Work" />
    <div className="work">
      <div className="section-title">
        <FontAwesomeIcon icon={faSquareFull} color="#1368f0" />
        <span className="name"> Projects</span>
      </div>
      {projects.map(experience => {
        return <ProjectEntry {...experience} />
      })}
    </div>
  </Layout>
)

export default WorkPage
